export default "/images/fdbdce1db71d130caf683c3906eb724c.avif";